/**
 * Returns true when a hex colour is perceptually dark (WCAG relative luminance < 0.5).
 * Accepts 3- or 6-digit hex strings with or without a leading '#'.
 * Returns false (treat as light) for invalid / missing input.
 */
export function isHexDark(hex: string | null | undefined): boolean {
  const h = (hex ?? '').replace('#', '');
  const expanded =
    h.length === 3
      ? h[0] + h[0] + h[1] + h[1] + h[2] + h[2]
      : h;
  if (!/^[0-9a-fA-F]{6}$/.test(expanded)) return false;
  const lin = (c: number) => {
    const s = c / 255;
    return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
  };
  const L =
    0.2126 * lin(parseInt(expanded.slice(0, 2), 16)) +
    0.7152 * lin(parseInt(expanded.slice(2, 4), 16)) +
    0.0722 * lin(parseInt(expanded.slice(4, 6), 16));
  return L < 0.5;
}
